import type { SVGProps } from 'react';

export const GoogleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' fill='none' {...props}>
    <path
      d='M6.00035 6.0909C6.00035 6.72327 6.51333 7.23624 7.14569 7.23624H9.26719C8.903 8.41938 8.00665 9.31634 6.71131 9.55572C4.65282 9.9367 2.59432 8.43678 2.39753 6.35249C2.19354 4.1956 3.88486 2.38069 6.00035 2.38069C6.60152 2.38069 7.16789 2.52828 7.66647 2.78807C8.12064 3.02505 8.67622 2.92966 9.038 2.56728C9.61037 1.99491 9.45858 1.02956 8.73921 0.659975C7.73246 0.142801 6.56072 -0.0983864 5.32419 0.0372067C2.57452 0.338391 0.338438 2.57268 0.0372532 5.32234C-0.359327 8.94016 2.46293 12 6.00035 12C9.82096 12 11.3833 9.29114 11.6995 6.96146C11.8447 5.89351 10.9903 4.95036 9.91275 4.94916L7.14689 4.94556C6.51393 4.94436 6.00035 5.45733 6.00035 6.0909Z'
      fill='currentColor'
    />
  </svg>
);
